import React, {useState} from "react";
import moment from "moment";

import ModalUpdateMangel from "./ModalUpdateMangel";
import ModalDeleteMangel from "./ModalDeleteMangel";
import useAuthorization from "../auth/useAuthorization";
import {prioritaetAnzeige, statusText} from "../utils/maengel";

const MangelBox = (props) => {
  const {canWrite} = useAuthorization();
  const [showModal, setShowModal] = useState(false);
  const [showModalDelete, setShowModalDelete] = useState(false);

  // Beschriftung und Einfärbung kommen aus derselben Quelle wie in der
  // Mängelliste — sonst hieße dieselbe Priorität hier und dort Verschiedenes.
  const {text: prioText, klasse: prio} = prioritaetAnzeige(
    props.mangel.priorität,
    props.mangel.status,
  );

  const kategorieToText = (kategorie) => {
    switch (kategorie) {
      case "1":
        return "Kategorie 1";
      case "2":
        return "Kategorie 2";
      case "3":
        return "Kategorie 3";
      default:
        return "Kategorie 4";
    }
  };

  const displayStatusUpdate = (mangel) => {
    if (mangel.statusNew !== mangel.statusOld) {
      return (
        <p className="mangelUpdateInfo">
          Status geändert von "{statusText(mangel.statusOld)}" auf "
          {statusText(mangel.statusNew)}"
        </p>
      );
    }
  };

  const displayKategorieUpdate = (mangel) => {
    if (mangel.kategorieNew !== mangel.kategorieOld) {
      return (
        <p className="mangelUpdateInfo">
          Kategorie geändert von "{kategorieToText(mangel.kategorieOld)}" auf "
          {kategorieToText(mangel.kategorieNew)}"
        </p>
      );
    }
  };

  const handleDoubleClick = () => {
    if (!canWrite) {
      return;
    }

    setShowModal(true);
  };

  const handleClose = () => {
    setShowModal(false);
  };

  const handleDeleteMangel = () => {
    if (!canWrite) {
      return;
    }

    setShowModalDelete(true);
  };

  const handleDeleteClose = () => {
    setShowModalDelete(false);
  };

  // const reversedHistorie = props.mangel.historie.toReversed();

  return (
    <>
      <ModalUpdateMangel
        showModal={showModal}
        close={handleClose}
        mangel={props.mangel}
        fahrzeug={props.fahrzeug}
        funkkennung={props.funkkennung}
        kategorien={props.kategorien}
      />
      <ModalDeleteMangel
        showModal={showModalDelete}
        close={handleDeleteClose}
        mangel={props.mangel}
        fahrzeug={props.fahrzeug}
      />
      <div
        className={"mangel " + prio}
        onDoubleClick={() => {
          handleDoubleClick();
        }}
      >
        <div className="mangelHeader">
          <div className="mangelInfo">
            {props.mangel.kontaktName}
            <br />
            Telefon: {props.mangel.kontaktTelefon}
            <br />
            E-Mail:{" "}
            <a href={"mailto:" + props.mangel.kontaktEmail}>
              {props.mangel.kontaktEmail}
            </a>
          </div>
          <div className="mangelPrio">
            {props.mangel.kilometer} km
            <br />
            {props.mangel.kategorie}
            <br />
            {prioText}
          </div>
        </div>
        {props.mangel.historie.map((item, index) => {
          let userTmp = item.nutzerkreis;
          if (userTmp === "") userTmp = props.mangel.kontaktName;

          let showEntry = false;
          if (index === 0 || index === props.mangel.historie.length - 1)
            showEntry = true;
          if (props.showAll) showEntry = true;

          if (showEntry) {
            return (
              <div className="mangelEntry" key={index}>
                <div>
                  <p
                    style={{
                      fontWeight: "bold",
                      marginBottom: "5px",
                      borderBottom: "1px solid gray",
                    }}
                  >
                    {userTmp},{" "}
                    {moment
                      .unix(item.datum.seconds)
                      .format("DD.MM.YYYY, HH:MM")}{" "}
                    Uhr:
                  </p>
                  <p className="mangelInfoText">{item.beschreibung}</p>
                  {/* {displayPrioUpdate(item)} */}
                  {displayStatusUpdate(item)}
                  {displayKategorieUpdate(item)}
                </div>
              </div>
            );
          } else return undefined;
        })}
        <div className="mangelDelete">
          {canWrite ? (
            <span
              onClick={() => {
                handleDeleteMangel();
              }}
            >
              Mangel löschen
            </span>
          ) : undefined}
        </div>
      </div>
    </>
  );
};

export default MangelBox;
